export default "__VITE_ASSET__dXFaV1MM__"